import { ErrorNotice, Notice } from "@/components/tool-kit/primitives";
import type { SPECIFIC_HEAT_CALCULATOR_STRINGS } from "@/components/tools/specific-heat-calculator";
import { t } from "@/lib/i18n/interpolate";

export type HeatStrings = typeof SPECIFIC_HEAT_CALCULATOR_STRINGS;

/** Message templates by failure reason; `{label}` names the entry at fault. */
export type FailureMessages = Record<string, string>;

export interface Failure {
  reason: string;
  key?: string;
}

export function heatMessages(strings: HeatStrings): FailureMessages {
  return {
    missing: strings.enterValues,
    unreadable: strings.errorUnreadable,
    nonPositive: strings.errorNonPositive,
    belowZero: strings.errorBelowZero,
    zeroValue: strings.errorZeroValue,
    phaseMismatch: strings.errorPhase,
    zeroChange: strings.errorZeroChange,
    signMismatch: strings.errorSignMismatch,
    resultBelowZero: strings.errorResultBelowZero,
    outsideRange: strings.errorOutsideRange,
  };
}

/** The message for a failed calculation; `labels` names each entry key. */
export function failureText(
  failure: Failure,
  messages: FailureMessages,
  labels: Record<string, string>
): string {
  const template = messages[failure.reason] ?? failure.reason;
  const key = failure.key ?? "";
  return t(template, { label: labels[key] ?? key });
}

export function FailureNotice({
  failure,
  messages,
  labels,
}: {
  failure: Failure;
  messages: FailureMessages;
  labels: Record<string, string>;
}) {
  const message = failureText(failure, messages, labels);
  return failure.reason === "missing" ? (
    <Notice>{message}</Notice>
  ) : (
    <ErrorNotice>{message}</ErrorNotice>
  );
}
